import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Context } from "../../state/context";
import { ROLE } from '../../enums/roles';
import { hasRole } from '../../utils/hasRole';

import KeyItemPlatform from '../key-item-platform/key-item-platform.component';
import KeyItemStatus from '../key-item-status/key-item-status.component';

import './key-item.styles.scss';

export default function KeyItem({ keyItem }) {
    const { state, dispatch } = useContext(Context);
    const history = useHistory();
    const [id, setId] = useState(0);
    const [text, setText] = useState("");
    const [status, setStatus] = useState("");
    const [deadline, setDeadline] = useState("");
    const [sourceString, setSourceString] = useState("");
    const [activeKeyText, setActiveKeyText] = useState("");
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        const { id, text, key_status, source_string, due_to } = keyItem;
        setId(id);
        setText(text);
        setStatus(key_status);
        setDeadline(due_to);
        if (source_string) {
            setSourceString(source_string);
        }
    }, [keyItem]);

    useEffect(() => {
        setActiveKeyText(state.activeKey.text);
    }, [state.activeKey]);

    useEffect(() => {
        setRoles(state.roles)
    }, [state.roles]);

    const keyClick = () => {
        history.push({
            path: window.location.pathname,
            search: `?key=${text}`
        });
        dispatch({ type: 'SET_ACTIVE_KEY', activeKey: { id, text, status, deadline } });
    };

    return (
        <li
            onClick={keyClick}
            className={`row key cursor-pointer d-flex align-items-center justify-content-between ${text === activeKeyText && "active"}`}>
            <div className={`d-flex flex-column ${hasRole(roles, ROLE.ADMIN) ? "col-8" : "col-10"} pr-0`}>
                <span className={"translation-key"}>{hasRole(roles, ROLE.ADMIN) ? text : `KEY NO: ${id}`}</span>
                <span className="translation-source">{sourceString}</span>
            </div>
            <div className={`d-flex align-items-center justify-content-end ${hasRole(roles, ROLE.ADMIN) ? "col-4" : "col-2"} pl-0`}>
                <KeyItemStatus className="mr-2" status={keyItem.status} />
                {hasRole(roles, ROLE.ADMIN) && <KeyItemPlatform platforms={keyItem.all_tags} />}
            </div>
        </li>
    )
}
